<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-8-contact-part-1">
<h1>Chapter 8<br/> Contact Part 1</h1>
<p>Bjorn and Zorn sit at the main console and discuss revealing themselves to the humans on Earth.</p>
<p>“What do you think is the best way to tackle this?” asks Bjorn.</p>
<p>“We can do this a few different ways. We could teleport in, in full view of a large crowd. Surely when they see us, they will realise they aren’t alone in the universe, and realise their ancient beliefs are a little wide of the mark,” says Zorn.</p>
<p>“That has it merits, but it sounds a little risky to me,” says Bjorn.</p>
<p>“How so?” asks Zorn.</p>
<p>“What if they don’t react how we think they will? I know when our people were controlled by religion, they wouldn’t have reacted particularly well,” says Bjorn.</p>
<p>“I hear you, but this species might actually be a little better developed than we were at this point in our development.”</p>
<p>“What? You think they are evolving quicker than we did?”</p>
<p>“Maybe.”</p>
<p>“I don’t know. I still think it’s risky. Why don’t we do it in the safety of shuttle pods?” says Bjorn.</p>
<p>“All right, how about this? We leave the cat in charge, and if we need to, he can teleport us out.”</p>
<p>“ONLY the cat. The others are a little down in the intelligence quotient,” says Bjorn.</p>
<p>“OK,” sniggers Zorn.</p>
<p>Florence, walking into the room, asks, “What are you laughing at?”</p>
<p>“Nothing, sweetheart, just a little alien humour,” says Bjorn.</p>
<p>Zorn calls out, “Dax, can you come here, please?”</p>
<p>Dax, walking into the room, expresses discomfort from last night’s dinner.</p>
<p>“What was in that curry? Bad news.”</p>
<p>“Never mind,” says Bjorn, “it will pass.” Bjorn and Zorn snigger again.</p>
<p>Zorn explains the plan to Dax.</p>
<p>“BJ and I are going to reveal ourselves to humanity and show them they aren’t alone in the universe. To show them we are here, to stop them from destroying themselves.”</p>
<p>Bjorn explains further, “We will teleport to the surface. We will show you how to maintain a lock on us, and you can bring us back if we get into trouble.” As Bjorn explains the procedure, he points to various buttons on the console. “OK. You will need to hit this blue button and watch the panel on the right for a full signal. If the signal weakens, you will need to hit this green button to realign. Blue button to bring us back. Got it?”</p>
<p>“I’ve seen you both do it heaps of times,” says Dax in an irritated tone.</p>
<p>“OK, smarty bum, explain it to me,” says Bjorn.</p>
<p>Pointing at the first button, “Hit the blue button to teleport you down, watch that panel to maintain lock, and hit the green button if we need to adjust. Blue button to bring you back.”</p>
<p>“Excellent, you got it in one,” says Zorn.</p>
<p>Zorn calls the animals to the console. He touches the screen, and a large red button appears.</p>
<p>“See that big red button? If everything goes wrong, then one of you has to hit that button as soon as you can. Got it?” The animals all nod in unison.</p>
<p>“Good, we are ready. BJ, Let’s go,” says Zorn.</p>
<p>“Before we go, what’s Plan B?” asks Bjorn.</p>
<p>“We’ll be fine. We don’t need Plan B.”</p>
<p>“You better be right.”</p>
<p>Bjorn and Zorn shape-shift into their normal cat/dog forms. Zorn nods to Dax, and he hits the button. Bjorn and Zorn disappear from the ship. Bjorn materialises at the Temple Mount in Jerusalem. Zorn materialises in front of the Statue of Liberty. We see two groups of people on either side of the temple. A crowd gathers around the foot of the Statue with Zorn. They speak in unison.</p>
<p>“I am Bjorn/Zorn from the planet of Aeon. I am here to tell you, that you are not alone in the universe. There is a great big universe out there, (pointing to the stars) full of wonders you can’t even imagine. Take our hand of friendship, and we can show it all to you. We can show you how to build ships to explore it all. You don’t need God to look after you, you can do it from within.”</p>
<p>The crowds greet them with complete silence and disbelief. Suddenly, someone in each crowd lurches forward to attack, and we hear a person yelling, “Witch.”</p>
<p>“Witch! Witch! Witch! Kill them,” yells the crowds.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch012.vue?188ee506